module.exports = __webpack_public_path__ + "static/media/guest_black.19a6e225.svg";